export default __webpack_public_path__ + "static/media/journal_sample.52e02a40.jpg";